import { useNavigate } from 'react-router-dom';
import { motion } from 'framer-motion';
import { ArrowRight } from 'lucide-react';

interface FreeTrialBannerProps {
  attemptsUsed: number;
  maxAttempts: number;
}

export default function FreeTrialBanner({
  attemptsUsed,
  maxAttempts,
}: FreeTrialBannerProps) {
  const navigate = useNavigate();
  const allUsed = attemptsUsed >= maxAttempts;
  const percentage = Math.min((attemptsUsed / maxAttempts) * 100, 100);

  return (
    <motion.button
      whileTap={{ scale: 0.98 }}
      whileHover={{ y: -1 }}
      onClick={() => navigate('/pricing')}
      className="group w-full bg-card rounded-2xl p-5 border border-border text-left cursor-pointer transition-colors hover:border-primary/30"
    >
      <div className="flex items-center justify-between mb-3">
        <span className="font-sans text-xs font-semibold uppercase tracking-wide text-text-muted">
          Free Plan
        </span>
        <span className="font-sans text-sm text-text-secondary">
          {attemptsUsed} of {maxAttempts} interviews used
        </span>
      </div>
      <div className="w-full h-2 bg-border rounded-full overflow-hidden">
        <div
          className={`h-full rounded-full transition-all duration-300 ${
            allUsed ? 'bg-warning' : 'bg-primary'
          }`}
          style={{ width: `${percentage}%` }}
        />
      </div>
      <div className="mt-3 flex items-center gap-1.5">
        <p
          className={`font-sans text-sm ${
            allUsed ? 'text-warning font-medium' : 'text-text-secondary'
          }`}
        >
          {allUsed
            ? 'Upgrade for unlimited interviews'
            : 'Upgrade anytime for unlimited access'}
        </p>
        <ArrowRight
          size={14}
          className={`transition-transform group-hover:translate-x-0.5 ${
            allUsed ? 'text-warning' : 'text-text-secondary'
          }`}
        />
      </div>
    </motion.button>
  );
}
